<template>
  <footer class="footer px-4">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="" class="font-weight-bold ml-1" target="_blank">Amine SAIDI</a> &
          <a href="https://www.omarmhiri.com" class="font-weight-bold ml-1" target="_blank">Omar Mhiri</a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
